<template>
  <div class="app-header">
    <fa @click="toggleNav" icon="bars" size="lg" class="hide-mobile nav-button" />
    <fa @click="toggleNav" icon="bars" size="lg" v-if="!hideMenu" class="show-mobile nav-button" />
    <div v-else />
    <img class="logo" src="@/assets/logo.png" />
    <el-dropdown class="user-dropdown">
      <span class="el-dropdown-link">
        <div class="user-initials">{{ initials }}</div>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="$router.push({ name: 'Profile' })"><fa icon="cog" fixed-width /> Settings</el-dropdown-item>
        <el-dropdown-item divided><div @click="this.signOut"><fa icon="sign-out-alt" fixed-width /> Sign out</div></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    toggleNav: {
      type: Function,
      required: true
    },
    hideMenu: Boolean
  },
  data () {
    return {}
  },
  computed: {
    initials () {
      const split = this.$auth.user.email.split(' ')
      let intials = ''
      for (let i = 0; i < split.length; i++) {
        intials += split[i][0]
      }
      return intials
    }
  },
  methods: {
    signOut () {
      this.$auth.logout()
      setTimeout(() => {
        this.$router.push('/')
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>

  .app-header {
    display: flex;
    justify-content: space-between; 
    align-items: center;

    @include breakpoint (xs) {

    }
  }

  .user-dropdown {
    @include breakpoint (xs) {
      display: none;
    }
  }

  .user {
    @include breakpoint (xs) {
      display: none;
    }
  }

  .credits {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    color: white;
  }

  .el-dropdown-link {
    display: flex;
    align-items: center;
    text-align: right;
    span {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12px;
      color: #909399;
      cursor: pointer;
    }
    .user-initials {
      margin-left: 10px;
      background-color: whitesmoke;
      color: #008fcc;
      font-weight: 600;
      text-align: center;
      width: 30px;
      height: 30px;
      line-height: 31px;
      border-radius: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Header.vue